<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
	export default({
		name:"App",
		components: {
		},
		created() {
			//两端判断是手机还是pc
			function IsPC(){  
			    var userAgentInfo = navigator.userAgent;
			    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
			    var flag = true;  
			        for (var v = 0; v < Agents.length; v++) {  
			            if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
			        }  
			            return flag;  
			 } 
			    var routerFlag = IsPC();
			    if(routerFlag){
					window.location.href="http://web.cn-imie.com/#/Home/page"
				}else{
					window.location.href="http://wap.cn-imie.com/#/pages/phonepagetwo"
				}
			//全局监听，页面刷新的时候将store里state的值存到sessionStorage中，然后从sessionStorage中获取，再赋值给store。
			//然后再把session里面存的删除即可，相当于中间件的作用。
			//在页面加载时读取sessionStorage里的状态信息
			if (sessionStorage.getItem("store")) {
				this.$store.replaceState(
					Object.assign(
						{},
						this.$store.state,
						JSON.parse(sessionStorage.getItem("store"))
					)
				);
				sessionStorage.removeItem("store")
			}
			//在页面刷新时将vuex里的信息保存到sessionStorage里
			window.addEventListener("beforeunload", () => {
				sessionStorage.setItem("store", JSON.stringify(this.$store.state));
			})
			   
		},
		mounted() {
			function checkIE(){
			      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
			    }
			    if (checkIE()) {
			      window.addEventListener('hashchange', () => {
			        var currentPath = window.location.hash.slice(1);
			        if (this.$route.path !== currentPath) {
			        this.$router.push(currentPath)
			      }
			    }, false)
		    }
			const script = document.createElement('script')
			    script.src = 'https://s95.cnzz.com/z_stat.php?id=1279650506&web_id=1279650506'
			    script.language = 'JavaScript'
			    document.body.appendChild(script)
		},
		watch: {
		    '$route' () {
		      if (window._czc) {
		        let location = window.location
		        let contentUrl = location.pathname + location.hash
		        let refererUrl = '/'
		        window._czc.push(['_trackPageview', contentUrl, refererUrl])
		      }
		    }
		  },
		methods:{
		}
	})
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body{
	margin: 0 ;
	padding: 0 ;
}
#nav {
  padding: 30px;
	
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
